// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ej-1";
export var dateTimeButtonsContainer = "_ej-6";
export var dateTimeInputContainer = "_ej-7";
export var dateTimeWrapper = "_ej-8";
export var disabledTile = "_ej-0";
export var header = "_ej-2";
export var line = "_ej-3";
export var snoozeOption = "_ej-4";
export var time = "_ej-5";
export var todayTile = "_ej-9";
export var wrapper = "_ej-a";